module.exports = __webpack_public_path__ + "static/media/React Hackers Meet-Up.be7af324.png";